import React, { useEffect, useRef } from "react";
import { Animated } from "react-native";
import { Text } from "react-native-elements";
import { colors, fonts } from "../styles";
import { atom, useSetRecoilState, useRecoilValue } from "recoil";

const loadingTextState = atom<string>({
  key: "LoadingText",
  default: "Authenticating...",
});

export const useLoadingText = (text: string) => {
  const setLoadingText = useSetRecoilState(loadingTextState);
  useEffect(() => {
    setLoadingText(text);
  }, [text]);
};

export const Loading: React.FC = () => {
  const opacity = useRef(new Animated.Value(0)).current;
  const loadingText = useRecoilValue(loadingTextState);

  useEffect(() => {
    const animation = Animated.timing(opacity, {
      toValue: 1,
      duration: 3000,
      useNativeDriver: true,
    });

    animation.start();
    return () => animation.stop();
  }, []);

  return (
    <Animated.View
      style={{
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        opacity: opacity,
      }}
    >
      <Animated.Text
        style={{
          color: colors.primary,
          fontSize: 64,
          lineHeight: 64,
          fontFamily: fonts.header,
          opacity: opacity,
        }}
      >
        BomData
      </Animated.Text>
      <Text>{loadingText}</Text>
    </Animated.View>
  );
};
